/*
  Naoko — wideo w banerze między rzędami listingu (snippet naoko-listing-inline-banner).
  Plan: docs/listing-inline-banner-plan.md („Wideo").

  Custom element <naoko-inline-video> — inicjalizuje się sam także po podmianie
  #ProductGridContainer.innerHTML przez facets.js (skrypty z innerHTML się nie
  wykonują, ale upgrade custom elementu tak). Zasady jak w naoko-collection-video:
  - prefers-reduced-motion / saveData → zostaje poster (<picture>), wideo nie startuje,
  - DOKŁADNIE jedno źródło mp4 (desktop ALBO mobile, wg data-src-*), przy przejściu
    przez 750 px źródło jest podmieniane,
  - start dopiero w kadrze (IntersectionObserver), pauza poza kadrem,
  - Safari: play() odrzucony bez gestu → ponowienie przy pierwszym geście,
  - bfcache / powrót karty → wznowienie.
*/
(function () {
  if (customElements.get('naoko-inline-video')) return;

  var MQ_MOBILE = '(max-width: 749px)';
  var GESTURES = ['pointerdown', 'touchend', 'keydown', 'click'];

  function motionAllowed() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && conn.saveData) return false;
    return true;
  }

  class NaokoInlineVideo extends HTMLElement {
    connectedCallback() {
      // Element zdefiniowany PRZED parsowaniem strony → connectedCallback odpala się na
      // tagu otwierającym, gdy dzieci (<video>) jeszcze nie ma. Inicjalizacja odroczona.
      if (this.inited) return;
      this.inited = true;
      setTimeout(this.init.bind(this), 0);
    }

    init() {
      if (!this.isConnected) { this.inited = false; return; }
      this.video = this.querySelector('video');
      if (!this.video || !motionAllowed()) return;
      this.mq = window.matchMedia ? window.matchMedia(MQ_MOBILE) : null;
      this.inView = false;
      this.onMq = this.applySource.bind(this);
      this.onPageShow = function (e) { if (e.persisted) this.resume(); }.bind(this);
      this.onVisibility = function () { if (!document.hidden) this.resume(); }.bind(this);
      if (this.mq && this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('visibilitychange', this.onVisibility);

      this.io = new IntersectionObserver(
        function (entries) {
          this.inView = entries[0].isIntersecting;
          if (this.inView) this.activate();
          else if (!this.video.paused) this.video.pause();
        }.bind(this),
        { rootMargin: '200px 0px', threshold: 0.01 }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.inited = false;
      if (this.io) this.io.disconnect();
      if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    currentSrc() {
      var isMobile = this.mq && this.mq.matches;
      var d = this.dataset.srcDesktop || '';
      var m = this.dataset.srcMobile || '';
      // Brak źródła dla bieżącego breakpointu = na tym breakpoincie jest zdjęcie, nie wideo.
      return isMobile ? m : d;
    }

    applySource() {
      var src = this.currentSrc();
      if (src === this.loadedSrc) return;
      var v = this.video;
      v.classList.remove('is-ready');
      while (v.firstChild) v.removeChild(v.firstChild);
      this.loadedSrc = src;
      if (!src) {
        v.removeAttribute('src');
        v.load();
        return;
      }
      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      // Mobile 720p to adres WYPROWADZONY z etykiety (Liquid zna tylko najcięższy mp4);
      // przy 404 wracamy do adresu oryginalnego (data-src-mobile-fallback), raz.
      var self = this;
      var fallback = this.mq && this.mq.matches ? this.dataset.srcMobileFallback : '';
      if (fallback && fallback !== src) {
        source.addEventListener('error', function () {
          if (self.loadedSrc !== src) return;
          self.loadedSrc = fallback;
          while (v.firstChild) v.removeChild(v.firstChild);
          var s2 = document.createElement('source');
          s2.src = fallback;
          s2.type = 'video/mp4';
          v.appendChild(s2);
          v.load();
          if (self.inView) self.tryPlay();
        }, { once: true });
      }
      v.appendChild(source);
      v.load();
      v.addEventListener('playing', function () { v.classList.add('is-ready'); }, { once: true });
      if (this.inView) this.tryPlay();
    }

    activate() {
      if (this.loadedSrc === undefined) this.applySource();
      else if (this.loadedSrc && this.video.paused) this.tryPlay();
    }

    resume() {
      if (this.inView && this.loadedSrc && this.video.paused && !this.video.ended) this.tryPlay();
    }

    tryPlay() {
      var v = this.video;
      v.muted = true;
      v.defaultMuted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(this.armGestureRetry.bind(this));
    }

    armGestureRetry() {
      if (this.gestureArmed) return;
      this.gestureArmed = true;
      var self = this;
      var retry = function () {
        for (var i = 0; i < GESTURES.length; i++) document.removeEventListener(GESTURES[i], retry, true);
        self.gestureArmed = false;
        if (self.inView && self.video.paused) self.tryPlay();
      };
      for (var i = 0; i < GESTURES.length; i++) {
        document.addEventListener(GESTURES[i], retry, { capture: true, passive: true });
      }
    }
  }

  customElements.define('naoko-inline-video', NaokoInlineVideo);
})();
